// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Icon } from "metabase/ui";

interface SidebarButtonProps {
  isSmallAppBar?: boolean;
  isNavBarEnabled?: boolean;
  isLogoVisible?: boolean;
}

export const SidebarButton = styled.button<SidebarButtonProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 1.5rem;
  background-color: var(--side-bg-color);
  padding: ${({ isSmallAppBar }) => (isSmallAppBar ? `0.5rem 0` : `1rem 0`)};
  &:hover{
    background-color: #426ab3dc;
    box-shadow: gray 0px 0px 5px;
  }
`;

interface SidebarIconProps {
  isLogoVisible?: boolean;
}

export const SidebarIcon = styled(Icon, {
  shouldForwardProp: (propName) => propName !== "isLogoVisible",
})<SidebarIconProps>`
  color: white;
  display: block;

  ${(props) =>
    !props.isLogoVisible &&
    css`
      
      color: var(--mb-color-text-white);
      width: 2.5rem;
      height: 1.5rem;
      &:hover {
        color: white;
        
      }
    `}
`;
